import { removerItemDoCarrinho, salvarOuAtualizarItemDoCarrinho } from '@/api/itemDoCarrinho'
import { ItemDoCarrinho } from '@/models/venda/Carrinho'
import { ItemDoCarrinhoServiceAdapter } from '@/usecases/venda/adapter/ItemDoCarrinhoServiceAdapter'
import { injectable } from 'inversify-props'

@injectable()
export class ItemDoCarrinhoService implements ItemDoCarrinhoServiceAdapter {
	salvarOuAtualizarItemDoCarrinho = async (carrinhoId: string, item: ItemDoCarrinho) =>
		await salvarOuAtualizarItemDoCarrinho(carrinhoId, item)

	removerItemDoCarrinho = async (produtoId: string, carrinhoId: string) =>
		await removerItemDoCarrinho(produtoId, carrinhoId)
}
